import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { MENU_ROUTES } from 'src/app/app.routes';

export function loginGuard() {
  const authService = inject(AuthService);
  const router = inject(Router);

  const dashboard = router.createUrlTree([MENU_ROUTES.myDashboard]);

  if (authService.isAuthenticated()) {
    return dashboard;
  } else {
    return true;
  }
}
